import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import PlayfairCyrillic from "./PlayfairDisplay-Regular-Cyrillic.woff2";
import PlayfairLatinExt from "./PlayfairDisplay-Regular-LatinExt.woff2";
import PlayfairLatin from "./PlayfairDisplay-Regular-Latin.woff2";

export const PlayfairFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: PlayfairCyrillic,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC },
  },
  {
    uri: PlayfairLatinExt,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT },
  },
  {
    uri: PlayfairLatin,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN },
  },
];
